export const GROUP_BASE_PATH = '/:entityName/:projectName/groups/:groupName';
export const GROUP_WORKSPACE_PATH =
  '/:entityName/:projectName/groups/:groupName/:tab(workspace)';

export const FULL_SCREEN_GROUP_PANEL_PATH =
  '/:entityName/:projectName/groups/:groupName/panel/:panelId';
export const FULL_SCREEN_GROUP_WORKSPACE_TAB_PANEL_PATH =
  '/:entityName/:projectName/groups/:groupName/:tab(workspace)/panel/:panelId';
export const FULL_SCREEN_GROUP_RUN_PANEL_PATH =
  '/:entityName/:projectName/groups/:groupName/:tab(runs)/:runName/panel/:panelId';

export const EMBEDDED_GROUP_PANEL_PATH =
  '/:entityName/:projectName/groups/:groupName/embed/panel/:panelId';

export const GROUP_WORKSPACE_PATHS = [
  GROUP_BASE_PATH,
  GROUP_WORKSPACE_PATH,
  FULL_SCREEN_GROUP_PANEL_PATH,
  FULL_SCREEN_GROUP_WORKSPACE_TAB_PANEL_PATH,
  EMBEDDED_GROUP_PANEL_PATH,
  // single-run mode paths
  '/:entityName/:projectName/groups/:groupName/:tab(runs)/:runName',
  '/:entityName/:projectName/groups/:groupName/:tab(runs)/:runName/:runTab',
  '/:entityName/:projectName/groups/:groupName/:tab(runs)/:runName/:runTab(code|files)/:filePath*',
  FULL_SCREEN_GROUP_RUN_PANEL_PATH,
];

export const GROUP_PATHS = [
  ...GROUP_WORKSPACE_PATHS,
  '/:entityName/:projectName/groups/:groupName/:tab(files)/:filePath*',
  '/:entityName/:projectName/groups/:groupName/:tab',
];
